<div class="admin-container" [hidden]="!isLoaded">

  <mat-toolbar class="no-background">
    <span *ngIf="inquiry">【管理者用】{{inquiry.category}}詳細</span>
    <span class="spacer"></span>
    <a mat-button class="add-link" routerLink="/admin/inquiry">
      <mat-icon>arrow_back</mat-icon>戻る
    </a>
  </mat-toolbar>

  <div class="inquiry-container" *ngIf="inquiry">

    <app-user-info
      [id]="inquiry.id"
      [title]="inquiry.title"
      [name]="inquiry.name"
      [login]="inquiry.login"
      [status]="inquiry.status"
      [priority]="inquiry.priority"
      [user_id]="inquiry.user_id"
      [email]="inquiry.email"
      [abh_key]="inquiry.login"
    ></app-user-info>

    <form [formGroup]="adminForm" (ngSubmit)="onUpdate()" class="admin-form">

      <mat-form-field appearance="outline" class="remark">
        <mat-label>管理者用メモ（非公開・4096文字まで）</mat-label>
        <textarea matInput formControlName="remark" rows="10" style="font-size: 14px;"></textarea>
        <mat-hint align="end">
          <span *ngIf="adminForm.get('remark')?.hasError('maxlength') && adminForm.get('remark')?.touched" class="inline-error">
            管理者用メモは4096文字以内で入力してください　
          </span>
          {{ adminForm.get('remark')?.value?.length || 0 }}/4096
        </mat-hint>
      </mat-form-field>

      <div class="form-right-row">

        @if ((inquiry.category==='出金依頼') && ['出金額確定', '出金済', '完了'].includes(adminForm.get('status')?.value)) {
          <mat-form-field appearance="outline" class="amount-form">
            <mat-label>確定出金額</mat-label>
            <input matInput appDecimalInput
              type="text" inputmode="decimal"
              formControlName="requested_amount"
              [scale]="adminForm.get('currency')?.value === 'JPY' ? 0 : 2"
              [readonly]="adminForm.get('status')?.value !== '出金額確定'">
            <mat-hint align="end">
              <span *ngIf="adminForm.get('requested_amount')?.touched && adminForm.get('requested_amount')?.invalid" class="inline-error">
                確定出金額を入力してください　
              </span>
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="currency-form">
            <mat-label>通貨</mat-label>
            @if (adminForm.get('status')?.value === '出金額確定') {
              <mat-select formControlName="currency">
                <mat-option *ngFor="let cur of Currencies" [value]="cur">{{ cur }}</mat-option>
              </mat-select>
            }
            @else {
              <input matInput type="text" formControlName="currency" [readonly]="true">
            }
            <mat-hint align="end">
              <span *ngIf="adminForm.get('currency')?.touched && adminForm.get('currency')?.invalid" class="inline-error">
                通貨を入力してください　
              </span>
            </mat-hint>
          </mat-form-field>

          <div class="currency-form">
            <div *ngIf="inquiry.withdrawal_transaction?.id > 0" style="height: 100%; vertical-align: middle; padding-top: 6px;">
              <a (click)="openTransaction(inquiry.withdrawal_transaction.id)" style="cursor: pointer;">送金処理管理<br>の詳細を開く</a>
            </div>
          </div>
        }
        @else {
          <div class="amount-form">&nbsp;</div>
          <div class="currency-form">&nbsp;</div>
          <div class="currency-form">&nbsp;</div>
        }

        <mat-form-field appearance="outline" class="admin-user-form">
          <mat-label>担当者（非公開）</mat-label>
          <mat-select formControlName="admin_user_id">
            <mat-option [value]="'__unassigned__'">(未割当)</mat-option>
            <mat-option *ngFor="let user of adminUsers" [value]="user.id">
              {{ user.user_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="sub-category-form">
          <mat-label>分類 (7文字以内推奨)</mat-label>

          <input
            matInput
            type="text"
            formControlName="sub_category"
            [matAutocomplete]="auto"
            #trigger="matAutocompleteTrigger"
            (click)="onSubCategoryClick(trigger)"
          />

          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredSubCategories" [value]="option">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="status-form">
          <mat-label>状態</mat-label>
          <mat-select formControlName="status">
            <mat-option *ngFor="let status of statusOptions" [value]="status">{{ status }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="priority-form">
          <mat-label>優先度（非公開）</mat-label>
          <mat-select formControlName="priority">
            <mat-option *ngFor="let priority of priorityOptions" [value]="priority">{{ priority }}</mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" [disabled]="adminForm.invalid" style="margin-top: 0.8em;">
          更新
        </button>
      </div>

      <div *ngIf="inquiry.status==='受付'" style="color: red; margin-top: 16px;">
        「受付」状態のままで放置なさらず、お問い合わせの内容を把握されましたら状態を「確認中」に更新する事を強く推奨いたします。<br>
        「受付」から「確認中」「対応中」に変更されますと、ユーザーに対して対応を開始した旨のメールが送信されますので、<b>ユーザーの心証を和らげる効果が期待でき、すなわち時間が稼げます。</b><br>
      </div>

      <div *ngIf="['出金額確定', '出金済', '完了'].includes(adminForm.get('status')?.value)" style="color: red; margin-top: 16px;">
        「出金額確定」状態以降は ↑ への入力に加えて、ユーザーへの返信で、「出金金額」「出金予定日」などの確定事項の詳細が記載されている事を確認して下さい。<br>
        「出金額確定」状態以降は前の状態には戻せず、「出金済」のみ状態変更が可能です。
      </div>

      <div class="" *ngIf="inquiry.status === '出金額確定' || inquiry.status === '出金済'">
        <div style="margin-top: 8px; font-weight: bold;">
          送金履歴
          （出金確定額：{{inquiry.withdrawal_transaction.currency}} {{formatAmount(inquiry.withdrawal_transaction.requested_amount, inquiry.withdrawal_transaction.currency)}} /
          送金済額：{{inquiry.withdrawal_transaction.currency}} {{formatAmount(inquiry.withdrawal_transaction.settled_amount, inquiry.withdrawal_transaction.currency)}} /
          未送金額：{{inquiry.withdrawal_transaction.currency}} {{formatAmount(inquiry.withdrawal_transaction.unpaid_amount, inquiry.withdrawal_transaction.currency)}}）
        </div>
        <table class="transaction-details">
          <tr>
            <th>ID</th>
            <th>送金日</th>
            <th>銀行への送金額（{{inquiry.withdrawal_transaction.currency}}）</th>
            <th>送金手数料（{{inquiry.withdrawal_transaction.currency}}）</th>
            <th>合計（{{inquiry.withdrawal_transaction.currency}}）</th>
            <th>銀行側の振込処理番号等</th>
            <th>備考</th>
          </tr>

          @if (inquiry.withdrawal_transaction.details.length > 0) {
          <tr *ngFor="let detail of inquiry.withdrawal_transaction.details">
            <td class="detail-id">{{detail.id}}</td>
            <td class="detail-date">{{formatDate(detail.transaction_date.toString(), true)}}</td>
            <td class="detail-amount">{{formatAmount(detail.amount_gross, inquiry.withdrawal_transaction.currency)}}</td>
            <td class="detail-amount">{{formatAmount(detail.fee, inquiry.withdrawal_transaction.currency)}}</td>
            <td class="detail-amount">{{formatAmount(detail.amount_net, inquiry.withdrawal_transaction.currency)}}</td>
            <td class="detail-ref">{{detail.transaction_ref}}</td>
            <td class="detail-remarks">{{detail.remarks}}</td>
          </tr>
          } @else {
            <tr><td colspan="6" style="text-align: center;">まだありません（ユーザ側で出金依頼の取り消しが可能です）</td></tr>
          }
        </table>
      </div>

    </form>

    <div class="toolbar">
      <button mat-stroked-button (click)="acc.openAll()">全部開く</button>
      <button mat-stroked-button (click)="acc.closeAll()" style="margin-left:8px; margin-right: 16px;">全部閉じる</button>
      <span>
      AI によるラベル付けと要約がある場合は、デフォルトでオリジナルのテキストは隠されています。<br>
      「ラベル」「要約」を確認し、心の準備をしてから、生の文章に向かい合うと良いでしょう。
      </span>
    </div>

    <mat-accordion #acc="matAccordion" [multi]="true">

      <div class="child-list" style="margin-bottom: 1.5em;">
        <div class="child-item" *ngFor="let child of inquiry.children">
          <div class="child-header">
            <strong>{{ child.name || child.login }}</strong>
            <span class="child-date">{{ child.created_at | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
          </div>

          @if (child.summary && child.summary.length > 0) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div>
                    AI によるラベル付けと要約<br>
                    （クリックでオリジナルのテキストを表示）
                  </div>
                </mat-panel-title>
                <mat-panel-description>
                  <div style="white-space: pre-wrap;">{{ child.summary }}</div>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="child-body"><br>{{ child.body }}</div>
            </mat-expansion-panel>
          }
          @else {
            <div class="child-body">{{ child.body }}</div>
          }

          <div *ngIf="child.attachments && child.attachments.length > 0">
            <h4>添付ファイル :</h4>

            <ul class="attachments">
              <li *ngFor="let file of child.attachments">
                <a (click)="downloadAttachment(file.id)" class="attachment-link">
                  <mat-icon>file_open</mat-icon>{{ file.filename }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </mat-accordion>

    <form [formGroup]="form" (ngSubmit)="submit()" enctype="multipart/form-data" *ngIf="inquiry.status !== '完了'">

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>返信（1000文字まで）</mat-label>
        <textarea matInput formControlName="body" rows="8" required></textarea>
        <mat-hint align="end">
          <span *ngIf="form.get('body')?.invalid && form.get('body')?.touched" class="inline-error">
            返信は必須です　
          </span>
          <span *ngIf="form.get('body')?.hasError('maxlength') && form.get('body')?.touched" class="inline-error">
            返信は1000文字以内で入力してください　
          </span>
          {{ form.get('body')?.value?.length || 0 }}/1000
        </mat-hint>
      </mat-form-field>

      <input type="file" #fileInput hidden multiple (change)="onFileChange($event)" />

      <div class="drop-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
        <p>ここにファイルをドロップまたは</p>
        <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">ファイルを選択</button>
        <p></p>
        <p>※ファイルは最大10個まで、1ファイルにつき20MB以内でアップロードしてください</p>

        <div *ngIf="selectedFiles.length > 0" class="mt-2">
          <mat-list>
            <mat-list-item *ngFor="let file of selectedFiles; let i = index">
              <div class="file-row">
                <button mat-icon-button color="warn" type="button" (click)="removeFile(i)" aria-label="削除">
                  <mat-icon>delete</mat-icon>
                </button>
                <span class="file-size">
                  ({{ file.size / (1024 * 1024) | number : '1.2-2' }} MB)
                </span>
                <span class="file-name">
                  {{ file.name }}
                </span>
              </div>
            </mat-list-item>
          </mat-list>
        </div>

      </div>

      <div class="upload-hint">
        <mat-hint align="end">{{ selectedFiles.length || 0 }}/10</mat-hint>
      </div>

      <mat-error *ngIf="form.get('files')?.hasError('maxFileSize')">
        {{ form.get('files')?.getError('maxFileSize')?.message }}
      </mat-error>

      <div style="text-align: right;">
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
          返信を登録
        </button>
      </div>

    </form>
  </div>

</div>
